import {FC, getProp, JSX} from '@gongxigames/framework/core/fragments/BuilderY';
import {Container as PixiContainer} from 'pixi.js';

export type CallBack = () => void;
export type ActionFunction = (displayObject: PixiContainer, next: CallBack) => void;
export type WrapChildren = [JSX.Element, ActionFunction[]];
export type ActionType = FC<RunnerProps>;

export type RunnerProps = {
    children: WrapChildren;
};

export function runActions<T extends JSX.Element>(instance: T, actions: ActionFunction[], done?: CallBack): void {
    let index = 0;

    function run(): void {
        const action = actions[index];

        index++;

        if (action) {
            action(instance as PixiContainer, run);
        } else {
            done?.();
        }
    }

    run();
}

export function $Wrap(props: RunnerProps): JSX.Element {
    const children = getProp(props.children);
    const [container, actions] = [...children] as WrapChildren;

    runActions(container, actions);

    return container;
};
